import { PdfExportLoginSummary } from "@main/pdf-exporting/pdf-exporting.models";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { IHash } from "@bbwt/interfaces";

@Component({
    selector: "pdf-export-summary",
    templateUrl: "./pdf-export-summary.component.html",
    styleUrls: ["./pdf-export-summary.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfExportSummaryComponent {
    @Input() summaries: IHash<PdfExportLoginSummary> = {};

    protected get processors(): string[] {
        return Object.keys(this.summaries);
    }

    protected getTotalItems(processor: string): number {
        const summary: PdfExportLoginSummary = this.summaries[processor];

        if (!summary) return 0;

        return summary.pendingItems + summary.processingItems;
    }

    protected getLoginItemsCount(processor: string): number {
        const summary: PdfExportLoginSummary = this.summaries[processor];

        return summary?.loginItemPositions?.length ?? 0;
    }

    protected getLoginProcessingItemsCount(processor: string): number {
        const summary: PdfExportLoginSummary = this.summaries[processor];

        return summary?.loginItemPositions?.reduce(position =>
            position < summary.processingItems ? 1 : 0, 0) ?? 0;
    }

    protected isProcessingItem(processor: string, position: number): boolean {
        const summary: PdfExportLoginSummary = this.summaries[processor];

        if (!summary) return false;

        return position < summary.processingItems;
    }

    protected isUserItemPosition(processor: string, position: number): boolean {
        const summary: PdfExportLoginSummary = this.summaries[processor];

        return summary?.loginItemPositions?.includes(position) ?? false;
    }

    protected getStatusIcon(processor: string, position: number): string {
        return this.isProcessingItem(processor, position) ? "pi pi-spin pi-spinner" : "pi pi-clock";
    }

    protected getSegmentWidth(processor: string): number {
        const totalItems: number = this.getTotalItems(processor);
        return totalItems > 0 ? 100 / totalItems : 0;
    }
}
